<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <div class="page-title">課題詳情</div>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="info" @click="onEdit">編輯課題</el-button>
      </el-col>
    </el-row>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 課題編號：{{ formLabelAlign.number }} </el-col>
        <el-col :span="12"> 語言 :{{ formLabelAlign.lang | language }} </el-col>
      </el-row>
      <el-row class="page-row-list">
        <el-col :span="12"> 描述：{{ formLabelAlign.name }} </el-col>
      </el-row>
      <vue-dividing-line title="範圍及練習"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 課題範圍：<span>{{ formLabelAlign.scope | scope}}</span></el-col>
        <!-- <el-col :span="12"> 課題範圍：<span v-if="formLabelAlign.lang == 0">{{ formLabelAlign.scope | scope}}</span><span v-else>{{ formLabelAlign.scope | scopeEn}}</span>  </el-col> -->
        <el-col :span="12"> 年級 :{{ formLabelAlign.gradeName }} </el-col>
      </el-row>
      <el-row class="page-row-list">
        <el-col :span="12">
          <div class="page-row-list">練習：</div>
          <div
            class="page-row-list action-link cursor"
            @click="onNumberClick(item.id)"
            v-for="(item, index) in formLabelAlign.practises"
            :key="index"
          >
            {{ item.number }}
          </div>
        </el-col>
      </el-row>
      <vue-dividing-line title="小測"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12">
          <div class="page-row-list">簡介圖片：</div>
          <div class="page-row-list" v-if="formLabelAlign.smallTest">
            <el-image
              style="width: 100px; height: 100px;"
              :src="formLabelAlign.smallTest.imageUrl"
            >
            </el-image>
            <div>{{fileName}}</div>
          </div>
        </el-col>
      </el-row>
      <el-table
        v-if="formLabelAlign.smallTest"
        :data="formLabelAlign.smallTest.practises"
        style="width: 100%;"
      >
        <el-table-column  label="練習"> 
          <template slot-scope="scope">
            <div class="page-row-list action-link cursor" @click="onNumberClick(scope.row.id)">{{ scope.row.number }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="randomNumber" label="隨機抽取">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getFileName} from "@/utils/is-rules";
import { getTopicsDetail } from "@/api/topics";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  computed:{
    fileName(){
      return getFileName(this.formLabelAlign.smallTest.imageUrl)
    }
  },
  data() {
    return {
      formLabelAlign: {},
    };
  },
  created() {
    this.getTopicsDetail();
  },
  methods: {
    onNumberClick(id){
      let path = `/practice/${id}`
      this.resolveRouter(path)
    },
    getTopicsDetail() {
      getTopicsDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
      });
    },
    onEdit() {
      let path = `/topic/${this.id}/edit`
      this.resolveRouter(path)
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 10px;
  background-color: #fff;
  margin-top: 20px;
}
</style>